import React, { useState, useLayoutEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import SalaryRevisionGroupsProvider, { useSalaryRevisionGroups } from 'contexts/salary-revision-groups'
import { useLocationStateIntent } from 'hooks/location-intent'
import { sendAppSignal } from 'hooks/app-signal'
import { ToggleButton, Badge } from './s'
import SidePanel from 'panels/side'
import Groups from './groups'

const RevisionGroupsPanel = ({ salt }) => {
    const {
        total,
        hasFetched
    } = useSalaryRevisionGroups()

    const [showing, setShowing] = useState(false)

    useLocationStateIntent({
        intent: 'show-salary-revision-groups-panel',
        action: () => toggleSidePanel(true),
        requirements: [!!total]
    })

    const toggleSidePanel = show => {
        setShowing(show)
        sendAppSignal('side-panel.toggle', show)
    }

    useLayoutEffect(() => () => toggleSidePanel(false), [])

    return (
        <>
            {(!!total && !!hasFetched) && (
                <ToggleButton
                    onClick={() => toggleSidePanel(true)}
                    disabled={showing}>
                    <Badge
                        number={total}
                        disabled={showing}
                        inline={true} />
                    <span className="text">
                        <FormattedMessage
                            id="salary_revision_heading_pending"
                            defaultMessage="Pending revisions" />
                    </span>
                </ToggleButton>
            )}
            <SidePanel
                show={!!showing}
                dismiss={() => toggleSidePanel(false)}>
                <Groups
                    dismiss={() => toggleSidePanel(false)}
                    salt={salt} />
            </SidePanel>
        </>
    )
}

export default props => (
    <SalaryRevisionGroupsProvider>
        <RevisionGroupsPanel {...props} />
    </SalaryRevisionGroupsProvider>
)